import { API } from "../../config/api/index";

//ALL TYPE WISE DATA RETURN
const initState = {
  savedServiceList: [],
  groupedServiceList: [],
};

//DEFINE ACCOUNT REDUCER FUNCTION
const SavedServiceReducer = (state = initState, action) => {
  switch (action.type) {
    case API.savedService.getList:
      return {
        ...state,
        savedServiceList: action.savedServiceList,
      };

    case API.savedService.groupList:
      return {
        ...state,
        groupedServiceList: action.groupedServiceList,
      };

    default:
      return state;
  }
};

//EXPORT ALL FUNCTION
export default SavedServiceReducer;
